import type Modal from './Modal';

class ModalHandle {
  constructor(private modal: Modal) {}

  scrollToTop() {
    this.modal.scrollToTop();
  }

  close() {
    this.modal.close();
  }
}

export default ModalHandle;
